/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit MemberCard.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-500.js"
import EffectiveDate from './EffectiveDate/view.js'
import Expires from './Expires/view.js'
import FirstName from './FirstName/view.js'
import LastName from './LastName/view.js'
import LogoArrows from 'DesignSystem/Svgs/LogoArrows/view.js'
import PolicyId from './PolicyId/view.js'
import React from 'react'
import Status from './Status/logic.js'
import { css } from "emotion"
Status.displayName = 'StatusLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  position: "relative",
width: 320,
height: 200,
flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
paddingTop: 20,
paddingRight: 20,
paddingLeft: 20})
styles.Vertical1 = css({label: 'Vertical1',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
zIndex: 1})
styles.Vertical2 = css({label: 'Vertical2',
  marginBottom: 16})
styles.Text = css({label: 'Text',
  color: "white",
fontFamily: "WonderUnitSans",
fontSize: 8,
fontWeight: 500,
opacity: 0.8,
letterSpacing: 1,
textTransform: "uppercase",
marginBottom: 4})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row"})
styles.Vertical3 = css({label: 'Vertical3',
  position: "absolute",
top: -70,
left: 100,
opacity: 0.1})

export default function MemberCard({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Verify/Result/Match/MemberCard"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="MemberCard.Vertical"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className={`views-block ${styles.Vertical}`}
>
<Status
 data-testid="MemberCard.Status"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/Status`}
/>
<div
 data-testid="MemberCard.Vertical:1"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className={`views-block ${styles.Vertical1}`}
>
<PolicyId
 data-testid="MemberCard.PolicyId"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/PolicyId`}
/>
<div
 data-testid="MemberCard.Vertical:2"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className={`views-block ${styles.Vertical2}`}
>
<span
 data-testid="MemberCard.Text"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className={`views-text ${styles.Text}`}
>
Member
</span>
<div
 data-testid="MemberCard.Vertical:3"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className="views-block"
>
<FirstName
 data-testid="MemberCard.FirstName"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/FirstName`}
/>
<LastName
 data-testid="MemberCard.LastName"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/LastName`}
/>
</div>
</div>
<div
 data-testid="MemberCard.Horizontal"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className={`views-block ${styles.Horizontal}`}
>
<EffectiveDate
 data-testid="MemberCard.EffectiveDate"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/EffectiveDate`}
/>
<Expires
 data-testid="MemberCard.Expires"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/Expires`}
/>
</div>
<div
 data-testid="MemberCard.Vertical:4"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
 className={`views-block ${styles.Vertical3}`}
>
<LogoArrows
 data-testid="MemberCard.LogoArrows"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match/MemberCard"
viewPath={`${viewPath}/LogoArrows`}
 width={250}
 height={250}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}